



























import { Component, Vue } from "vue-property-decorator";
import {
  GridColumnTypes,
  GridColumn,
  GridAction,
  GridActionEvent
} from "@/models/grids/column";
import { MetadataFieldTypes, LanguageDto } from "@/server/app.dtos";
import ConfigsService from "@/services/api/configs.service";
import { Getter } from "vuex-class";

@Component
export default class MetadataFieldsPage extends Vue {
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  optionsDialog: boolean = false;
  apiService: ConfigsService = new ConfigsService();
  columns: GridColumn[] = [
    {
      text: "Referência",
      value: "reference",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-6",
      editableRules: [this.$rules.minLenght(3)],
      hidden: true
    },
    {
      text: "Tipo",
      value: "typeId",
      type: GridColumnTypes.Dropdown,
      editable: true,
      editableClass: "col-6",
      editableRules: [this.$rules.required],
      arg: {
        items: [],
        itemText: "title",
        itemValue: "typeId",
        value: 0
      }
    },
    {
      text: "Grupo",
      value: "idMetadataGroup",
      type: GridColumnTypes.Dropdown,
      filterable: true,
      editable: true,
      editableClass: "col-6",
      editableRules: [this.$rules.required],
      arg: {
        items: [],
        itemText: "title",
        itemValue: "idMetadataGroup",
        value: null,
        clearable: true
      }
    },
    {
      text: "Título",
      value: "title",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      sortable: true,
      editableRules: [this.$rules.minLenght(3)]
    },
    {
      text: "Descrição",
      value: "description",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12"
    },
    {
      text: "Valor Pré definido",
      value: "default",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-6",
      hidden: true
    },
    {
      text: "Validações (Regex mode)",
      value: "validations",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-6",
      hidden: true
    },
    {
      text: "Obrigatório",
      value: "isRequired",
      type: GridColumnTypes.Boolean,
      editable: true,
      editableClass: "col-6",
      hidden: true
    }
  ];
  actions: GridAction[] = [
    {
      title: "Opções",
      icon: "las la-ellipsis-v",
      visible: (item: any) =>
        item.typeId == MetadataFieldTypes.SelectorSingle ||
        item.typeId == MetadataFieldTypes.SelectorMultiple
    }
  ];
  endpoint: string = "api/metadatafields";
  primary: string = "idMetadataField";
  optionsEndpoint: string | null = null;
  optionsColumns: GridColumn[] = [
    {
      text: "Título",
      value: "title",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-6",
      editableRules: [this.$rules.minLenght(3)]
    }
  ];
  optionsPrimary: string = "idMetadataFieldOption";

  constructor() {
    super();
    const array: any[] = [];
    Object.keys(MetadataFieldTypes)
      .filter((value: any) => isNaN(Number(value)) === false)
      .map((key: any) =>
        array.push({ title: MetadataFieldTypes[key], typeId: parseInt(key) })
      );
    this.columns[1].arg.items = array;
  }

  async created() {
    await this.apiService
      .Load(
        "api/MetadataGroups",
        "IdLanguage=" + this.currentLanguage.idLanguage
      )
      .then((response: any) => (this.columns[2].arg.items = response));
  }

  handleAction(data: GridActionEvent) {
    this.optionsEndpoint = null;
    setTimeout(() => {
      this.optionsDialog = true;
      this.optionsEndpoint = `api/metadatafields/${data.item.idMetadataField}/options`;
    }, 500);
  }
}
